import { schemaVersion } from 'src/app/Modules/idms/components/project-manager/models/projectDetails.model';
import { Organization, profileContactModel } from '../organization/organization.model';
import { User } from '../organization/user.model';
import { InstanceAssetType } from './instance-asset-type.model';
import { InstancesContext } from './instance-contexts.model';

export class InstanceModel {
    instanceId: string;
    instanceType: InstanceType;
    instanceContext: InstancesContext;
    instanceAssetType: InstanceAssetType;
    name: string;
    connectionString: string;
    startDate: string;
    endDate: string;
    connectionCredentials: Array<any>;
    settings: Array<any>;
    notes: string;
    logo: string;
    organisation: Organization;
    profileContact: profileContactModel;
}

export class InstanceType {
    instanceTypeId: string;
    index: number;
    name: string;
}

export class InstanceForDashboard {
    instanceId: string;
    instanceType: InstanceType;
    logo: string;
    name: string;
    instanceContext: InstancesContext;
    instanceAssetType: InstanceAssetType;
    notes?: string;
    userCount?: string;
}

export class InstanceUsers {
    connectionString: string;
    endDate: string;
    instanceId: string;
    name: string;
    notes: string;
    startDate: string;
    users: Instanceuser[];
}

export class Instanceuser {
    userInstanceId: string;
    editedDate: string;
    user: User;
}

export class ViewDto {
    ViewId: string;
    HierarchyId: string;
    Name: string;
    Ordinal: string;
    IsDefault: string;
    IsDocument: string;
    EditedDate: string;
}

export class Child {
    taggedItemType: TaggedItemType;
    children: Child[];
    editedDate: string;
}

export class ConnectorHierarchy {
    taggedItemType: TaggedItemType;
    children: Child[];
    editedDate: string;
}

export class Root {
    name: string;
    connectorHierarchy: ConnectorHierarchy[];
    editedDate: string;
}

export class SchemaRevision {
    schema: string;
}

export class TaggedItemType {
    taggedItemTypeId?: string;
    name: string;
    description: string;
    icon: string;
    schemaRevision?: SchemaRevision;
    schemaVersions?: schemaVersion[];
    editedDate?: string;
    defaultSchema?: string;
    canAllocate: boolean;
    isCustom?: boolean = false;
}
export interface HierarchyDto {
    HierarchyId: string;
    Name: string;
}
